module.exports = __webpack_public_path__ + "media/background_2.8a63b766.mp4";